<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="footer-desc">
        以上内容均由AI生成，仅供参考和借鉴 | 全程陪伴您的毕业设计，提供从需求分析到答辩支持的全流程服务
      </div>
      <div class="footer-copy">
        © 2024 - present 极客码艺工作室 |
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">渝ICP备2025065693号</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HelperFooter"
}
</script>

<style scoped>
.footer {
  background: #f4f4f4;
  color: #4b5563;
  margin-top: auto;
}

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 6px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.footer-desc {
  font-size: 12px;
  color: #4b5563;
  text-align: center;
  line-height: 1.4;
}

.footer-copy {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  white-space: nowrap;
}

.footer-copy a {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-copy a:hover {
  color: #2563eb;
}
</style>
